import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { LoadingIndicatorService } from '../shared/loading-indicator.service';

export const turnOnIndicatorResolver: ResolveFn<void> = (route, state) => {
  return inject(LoadingIndicatorService).loadingOn();
};
